<template>
    <el-container direction="vertical">
        <el-col justify="start" class="pr10">
            <el-form :model="expense" label-position="top">
                <div class="expense-main">
                    <template v-if="!isNew">
                        <el-row class="mb10">
                            <el-col :span="8" class="gray">
                                Дата создания
                            </el-col>
                            <el-col :span="16">
                                {{ expense.created_at }}
                            </el-col>
                        </el-row>
                    </template>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Создатель
                        </el-col>
                        <el-col :span="16">
                            <el-select
                                v-model="expense.created_by_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                :placeholder="expense.created_by_full_name"
                                size="mini"
                            >
                                <el-option v-for="item in employersList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Получил - тип
                        </el-col>
                        <el-col :span="16">
                            <template v-if="!isNew">
                                {{ this.getName(this.receivedFromTypesList, expense.recipient_type) }}
                            </template>
                            <template v-else>
                                <template v-if="isPrepaymentPage">
                                    {{ localReferences.expenseRecipientName.employer }}
                                </template>
                                <template v-else>
                                    <el-select
                                        v-model="expense.recipient_type"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        clearable
                                        size="mini"
                                        @change="expenseDetailTypeToNull()"
                                    >
                                        <el-option v-for="item in receivedFromTypesListRegular" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </template>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <template v-if="expense.recipient_type !== localReferences.expenseRecipient.cash">
                            <el-col :span="8" class="gray">
                                Получил
                            </el-col>
                            <el-col :span="16">
                                <el-select
                                    v-model="expense.recipient_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in receivedByIdList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                        </template>
                        <template v-else>
                            <el-col :span="8" class="gray">
                                &nbsp;
                            </el-col>
                            <el-col :span="8">
                                <el-select
                                    v-model="expense.recipient_office_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    collapse-tags
                                    clearable
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                            <el-col :span="1" class="gray">
                            &nbsp;
                            </el-col>
                            <el-col :span="7">
                                <el-select
                                    v-model="expense.recipient_pay_type_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    collapse-tags
                                    clearable
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                        </template>
                    </el-row>
                    <div class="mb10" v-for="value in expense.details" :key="value.id">
                        <el-row class="mb10">
                            <el-col :span="8" class="gray">
                                Статья
                            </el-col>
                            <el-col :span="8">
                                <template v-if="isPrepaymentPage">
                                    {{ localReferences.expenseTypeName.prepayment }}
                                </template>
                                <template v-else>
                                    <el-select
                                        v-model="value.expense_type"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        collapse-tags
                                        clearable
                                        size="mini"
                                        :disabled="value.expense_type === 'refund_to_client'"
                                        @change="notifyDetailsInfo(value.expense_type)"
                                    >
                                        <el-option v-for="item in expenseTypeListComputed" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </template>
                            </el-col>
                            <el-col :span="4" class="gray">
                                <span class="expense-type-amount">Сумма,руб</span>
                            </el-col>
                            <el-col :span="4" class="gray">
                                <auto-numeric
                                    v-model="value.amount"
                                    :options="numericOptions"
                                    :class="[
                                        'autonumeric'
                                    ]"
                                />
                            </el-col>
                        </el-row>
                    </div>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Отчётный период
                        </el-col>
                        <el-col :span="14" class="period-select">
                            <div class="filter-label">
                                Год
                            </div>
                            <el-select
                                v-model="expense.period_year"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                placeholder="Год"
                                size="mini"
                                clearable
                                class="period-select-year"
                            >
                                <el-option v-for="item in localReferences.yearsList" :key="item" :label="item" :value="item" />
                            </el-select>
                            <div class="filter-label">
                                Месяц
                            </div>
                            <el-select
                                v-model="expense.period_month"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                placeholder="Месяц"
                                size="mini"
                                class="period-select-month"
                            >
                                <el-option v-for="item in localReferences.monthsList" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <template v-if="expense.source_type === localReferences.expenseSource.cash">
                        <el-row class="mb10">
                            <el-col :span="8" class="gray">
                                Касса
                            </el-col>
                            <el-col :span="8">
                                <el-select
                                    v-model="expense.source_office_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    collapse-tags
                                    clearable
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                            <el-col :span="1" class="gray">
                                &nbsp;
                            </el-col>
                            <el-col :span="7">
                                <el-select
                                    v-model="expense.source_pay_type_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    collapse-tags
                                    clearable
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                        </el-row>
                    </template>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Дата расхода
                        </el-col>
                        <el-col :span="16">
                            <el-date-picker
                                v-model="expense.date"
                                type="date"
                                placeholder="дд.мм.гггг"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                :clearable="false"
                                size="mini"
                                class="w100"
                            />
                            <div class="field-error bold" v-if="errors.date" v-text="errors.date[0]"></div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Комментарий
                        </el-col>
                        <el-col :span="16" class="gray">
                            <el-input
                                size="mini"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder=""
                                v-model="expense.comment"
                            />
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Сумма,руб
                        </el-col>
                        <el-col :span="16">
                            {{ calculateAmount > 0 ? formatFinance(calculateAmount) : 0 }}
                        </el-col>
                    </el-row>
                    <el-row class="text-center pt16">
                        <el-col>
                            <template v-if="isNew">
                                <el-button type="warning" @click="create">
                                    Создать
                                </el-button>
                            </template>
                            <template v-else>
                                <el-button type="warning" @click="save">
                                    Применить
                                </el-button>
                            </template>
                            <el-button type="info" @click="close">
                                Отменить
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </el-col>
    </el-container>
</template>
<script>
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import ExpenseMixin from '@/mixins/expense';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import moment from 'moment';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import '@/assets/styles/card.scss';
import { formatFinance } from '@/common/utilities';
import ExpenseDealEdit from '@/components/expenses/ExpenseDealEdit';
import localReferences from '@/helpers/localReferences';

const initialExpense = {
    id: null,
    created_by_id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    amount_formatted: ''
};

export default {
    name: 'ExpenseRegularEdit',
    components: {
        AutoNumeric
    },
    mixins: [
        ExpenseMixin
    ],
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            expense: {
                id: null,
                created_at: null,
                created_by_id: this.$store.state.auth.employerId,
                date: null,
                recipient_type: '',
                recipient_id: null,
                source_type: 'cash',
                source_id: null,
                source_office_id: null,
                source_pay_type_id: null,
                recipient_office_id: null,
                recipient_pay_type_id: null,
                pay_type_id: 1,
                period_year: '',
                period_month: '',
                report_date: '',
                details: [{
                    expense_type: null,
                    amount: 0
                }],
                comment: '',
                amount: 0
            },
            created_by_name: '',
            errors: [],
            loadingMain: false,
            period: [],
            counter: 0,
            amount: 0
        };
    },
    computed: {
        isNew() {
            return this.id === -1;
        },
        expenseTypeListComputed() {
            if (this.expense.recipient_type === 'cash') {
                const cashExpenses = ['correction', 'other'];
                return this.expenseTypeList.filter(item => cashExpenses.includes(item.id));
            }
            if (this.expense.recipient_type === 'employer') {
                const employerExpenses = ['salary_cash', 'salary_cashless', 'bonus', 'efficiency_payment', 'prepayment', 'fine', 'debt_paid', 'salary', 'additional_work'];
                return this.expenseTypeList.filter(item => employerExpenses.includes(item.id));
            }
            if (this.expense.recipient_type === 'contractor') {
                const contractorExpenses = ['fine', 'debt_paid', 'rent', 'communications', 'advertising', 'other', 'unexpected', 'bank_comission', 'taxes_fot', 'taxes', 'reward_cards', 'reward_m_company'];
                return this.expenseTypeList.filter(item => contractorExpenses.includes(item.id));
            }
            if (this.expense.recipient_type === 'contact') {
                const contractorExpenses = ['refund_to_client'];
                return this.expenseTypeList.filter(item => contractorExpenses.includes(item.id));
            }
            return this.expenseTypeList;
        },
        calculateAmount() {
            let amount = 0;
            if (this.expense.details !== undefined) {
                amount = this.expense.details.reduce((previousValue, currentValue) => previousValue + currentValue.amount, amount);
            }
            return amount;
        },
        recipientOfficeId() {
            return this.expense.recipient_office_id;
        },
        recipientPayTypeId() {
            return this.expense.recipient_pay_type_id;
        },
        sourceOfficeId() {
            return this.expense.source_office_id;
        },
        sourcePayTypeId() {
            return this.expense.source_pay_type_id;
        },
        isPrepaymentPage() {
            if (this.$store.state.expenses.currentPage === localReferences.expensePage.prepayments) {
                return true;
            }
            return false;
        }
    },
    methods: {
        formatFinance,
        async getExpense() {
            this.loadingMain = true;
            try {
                const remoteExpense = await this.$store.dispatch('expenses/getExpense', this.id);
                Object.keys(this.expense).map(exp => {
                    this.expense[exp] = remoteExpense[exp];
                });
                const cash = this.$store.state.references.cashes.filter(cash => cash.id === this.expense.source_id);
                if (cash !== -1) {
                    this.expense.office_id = cash[0].office_id;
                }
                if (!this.isNew) {
                    this.setCashParams();
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingMain = false;
            }
        },
        async createExpense() {
            this.loadingMain = true;
            try {
                if (this.expense.details.length > 0) {
                    this.expense.amount = (this.expense.details.reduce((previousValue, currentValue) => previousValue + currentValue.amount), 0);
                }
                this.expense.report_date = this.getPeriod();
                this.expense = await this.$store.dispatch('expenses/createExpense', { ...this.expense });
                this.actionAfterSave();
                this.$emit('getDataFromServer');
            } catch (e) {
                this.errors = JSON.parse(e.message);
                this.actionAfterSaveError();
            } finally {
                this.loadingMain = false;
            }
        },
        create() {
            this.createExpense();
        },
        async updateExpense() {
            this.loadingMain = true;
            try {
                var amount = 0;
                this.expense.details.forEach(detail => {
                    amount += detail.amount;
                });
                this.expense.amount = amount;
                this.expense.report_date = this.getPeriod();
                console.log(this.expense);
                this.expense = await this.$store.dispatch('expenses/updateExpense', { ...this.expense });
                this.actionAfterSave();
                this.$emit('getDataFromServer');
            } catch (e) {
                this.errors = JSON.parse(e.message);
                this.actionAfterSaveError();
            } finally {
                this.loadingMain = false;
                this.isSaveButtonPressed = false;
            }
        },
        expenseDetailTypeToNull() {
            if (this.expense.details.length === 0) {
                return;
            }
            this.expense.details.forEach(function(value) {
                value.expense_type = null;
            });
        },
        setCashParams() {
            if (this.expense.source_type === localReferences.expenseSource.cash) {
                const cash = this.getCash(this.expense.source_id);
                if (cash) {
                    this.expense.source_pay_type_id = cash.pay_type_category_id;
                    this.expense.source_office_id = cash.office_id;
                }
            }
            if (this.expense.recipient_type === localReferences.expenseRecipient.cash) {
                const cash = this.getCash(this.expense.recipient_id);
                if (cash) {
                    this.expense.recipient_pay_type_id = cash.pay_type_category_id;
                    this.expense.recipient_office_id = cash.office_id;
                }
            }
        },
        notifyDetailsInfo(detail) {
            if (detail === 'refund_to_client') {
                this.$notify({
                    title: 'Ошибка',
                    message: 'Создание расхода на возврат покупателю производится из сделки',
                    type: 'error',
                    duration: 60000
                });
            }
        },
        open() {
            return true;
        },
        close() {
            this.$emit('closePopUp', false);
        },
        save() {
            if (this.isSaveButtonPressed) {
                return;
            }
            this.isSaveButtonPressed = true;
            this.updateExpense();
        },
        actionAfterSave() {
            this.$message({
                showClose: true,
                message: 'Расход сохранён',
                type: 'success',
                duration: 5000,
                customClass: this.alertClass()
            });
            this.$emit('closePopUp', false);
        },
        actionAfterSaveError() {
            this.$message({
                showClose: true,
                message: 'Расход не сохранён',
                type: 'error',
                duration: 5000,
                customClass: this.alertClass()
            });
        }
    },
    created() {
        if (!this.isNew) {
            this.getExpense();
        } else {
            if (this.isPrepaymentPage) {
                this.expense.recipient_type = localReferences.expenseRecipient.employer;
                this.expense.details[0].expense_type = localReferences.expenseType.prepayment;
            }
        }
    },
    watch: {
        recipientOfficeId: function(val, oldVal) {
            if (this.expense.recipient_type !== localReferences.expenseRecipient.cash) {
                return;
            }
            if (this.expense.recipient_pay_type_id) {
                const cash = this.getCashByParams(this.expense.recipient_pay_type_id, val);
                this.expense.recipient_id = cash ? cash.id : null;
                this.expense.pay_type_id = cash ? cash.pay_type_category_id : null;
            }
        },
        recipientPayTypeId: function(val, oldVal) {
            if (this.expense.recipient_type !== localReferences.expenseRecipient.cash) {
                return;
            }
            if (this.expense.recipient_office_id) {
                const cash = this.getCashByParams(val, this.expense.recipient_office_id);
                this.expense.recipient_id = cash ? cash.id : null;
                this.expense.pay_type_id = cash ? cash.pay_type_category_id : null;
            }
        },
        sourceOfficeId: function(val, oldVal) {
            if (this.expense.source_type !== localReferences.expenseSource.cash) {
                return;
            }
            if (this.expense.source_pay_type_id) {
                this.expense.source_id = this.getCashId(this.expense.source_pay_type_id, val);
            }
        },
        sourcePayTypeId: function(val, oldVal) {
            if (this.expense.source_type !== localReferences.expenseSource.cash) {
                return;
            }
            if (this.expense.source_office_id) {
                this.expense.source_id = this.getCashId(val, this.expense.source_office_id);
            }
        }
    }
};
</script>
